const guiColors = {
    'motion-primary': 'hsla(260, 100%, 70%, 1)',
    'motion-primary-transparent': 'hsla(260, 100%, 70%, 0.9)',
    'motion-tertiary': 'hsla(260, 55%, 55%, 1)',

    'looks-secondary': 'hsla(260, 100%, 70%, 1)',
    'looks-transparent': 'hsla(260, 100%, 70%, 0.35)',
    'looks-light-transparent': 'hsla(260, 100%, 70%, 0.15)',
    'looks-secondary-dark': 'hsla(260, 55%, 55%, 1)',

    'extensions-primary': 'hsla(270, 85%, 70%, 1)',
    'extensions-tertiary': 'hsla(270, 85%, 45%, 1)',
    'extensions-transparent': 'hsla(270, 85%, 70%, 0.35)',
    'extensions-light': 'hsla(270, 57%, 90%, 1)',

    'drop-highlight': 'hsl(260, 100%, 83%)'
};

const blockColors = {
    checkboxActiveBackground: 'hsl(260, 100%, 70%)',
    checkboxActiveBorder: 'hsl(260, 55%, 55%)'
};

export {
    guiColors,
    blockColors
};